function CalendarIcon() {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.06177 6.26833H13.9444"
        stroke="#5570F1"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.9614 8.8699H10.9675"
        stroke="#5570F1"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.0031 8.8699H8.00928"
        stroke="#5570F1"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.03862 8.8699H5.0448"
        stroke="#5570F1"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.9614 11.4636H10.9675"
        stroke="#5570F1"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.0031 11.4636H8.00928"
        stroke="#5570F1"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.03862 11.4636H5.0448"
        stroke="#5570F1"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.6958 1.33203V3.52588"
        stroke="#5570F1"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.31039 1.33203V3.52588"
        stroke="#5570F1"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.8255 2.38672H5.18064C3.22285 2.38672 2 3.47734 2 5.48207V11.5152C2 13.5514 3.22285 14.6673 5.18064 14.6673H10.8193C12.7833 14.6673 14 13.5703 14 11.5656V5.48207C14.0062 3.47734 12.7895 2.38672 10.8255 2.38672Z"
        stroke="#5570F1"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default CalendarIcon;
